import * as _ from 'lodash';

import {
  Component,
  ViewEncapsulation,
  Input
} from '@angular/core';

import {
  Router,
  ActivatedRoute,
  NavigationEnd,
  NavigationStart
} from '@angular/router';

import {
  UserContext
} from '../../../../services/user-context';

import {
  ApiService,
  AuthService,
  Util
} from '../../../../services';
import {LocationSummaryService} from '../../../../services/location-summary-service';
import {BehaviorSubject} from 'rxjs';
import {SearchContext} from '../../../../services/search/search-context';
import {CommissionsService} from '../../../../commissions/commissions.service';

@Component({
  selector: 'app-page-header',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './page-header.template.html',
  styleUrls: [
    './page-header.style.scss'
  ]
})
export class PageHeaderComponent {

  term:string;

  public previousPath: string;
  public requests: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public commissions: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  userOption:Array<any> = [{
    actionName:this.userContext.user.name,
    subtitle:"Edit profile",
    icon:"perm_contact_calendar",
    click: (dataItem) => {
      this.router.navigate(['profile']);
    }
  },{
    actionName: 'Log out',
    subtitle:"Safely disconnect",
    icon: 'exit_to_app',
    click: (dataItem) => {
      this.authService.logout();
    }
  }];

  constructor(private router: Router,
              private util: Util,
              private api: ApiService,
              private userContext: UserContext,
              private searchContext: SearchContext,
              private commissionsService: CommissionsService,
              private authService: AuthService,
              private locationSummaryService: LocationSummaryService,
              private activatedRoute: ActivatedRoute ) {

    this.userContext.appointmentsObserver.subscribe((appointments:any[]) => {
      if( appointments ) {
        //console.log("Filtering appointments for requests:" + JSON.stringify(appointments, null,4));
        this.requests.next(appointments.filter(a => (!a.confirmed && !a.invitation)));
      }
    });

    this.commissionsService.commissionsObserver.subscribe((commissions:any[]) => {
      if( commissions ) {
        //console.log("Filtering appointments for requests:" + JSON.stringify(appointments, null,4));
        this.commissions.next(commissions.filter(a => !a.paid));
      }
    });

    this.router.events.subscribe((event: any) => {

      if (event instanceof NavigationEnd) {

        const lastActivatedRoute = this.util.getLastActivatedRoute(this.activatedRoute);
        this.previousPath= this.util.getFullRoutePathByActivatedRoute('', lastActivatedRoute);

        this.searchContext.searchObserver.next('');
        this.term = '';
      }
    });
  }

  public onChange($event) {
    this.searchContext.searchObserver.next($event);
  }

  public resetAccount() {
    this.userContext.resetAccount();
    this.locationSummaryService.clear();
    this.router.navigate(['', 'accounts']);
  }

  get currentUser(): any {
    return this.userContext.user;
  }

  public isAdministrator() {
    return this.userContext.hasRole('administrator');
  }

  public isAdministratorOrManager() {
    return this.userContext.hasRole('administrator') || this.userContext.hasRole('manager');
  }

  public logout() {
    this.authService.logout();

    this.router.navigate(['auth', 'login']);
  }

  get locations(): any[] {
    return this.locationSummaryService.locationSummary;
  }

  openStore(location: any) {
    //console.log("Using context: " + JSON.stringify(this.userContext.account,null,4));
    if ( this.userContext.account.billing.currency === 'USD' ) {
      const url = `https://store.fitsamerica.com/#/location/${location.id}/shop`;
      window.open(url);
    } else {
      const url = `https://store.fitscanada.com/#/location/${location.id}/shop`;
      window.open(url);
    }
  }
}
